import { resumeData } from "../../Data/resume";

const HeroSection = () => {
  return (
    <section className="min-h-[80vh] flex flex-col justify-center py-16 md:py-24">
      <div className="animate-fade-in-up">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-card-border bg-card-bg text-xs font-medium text-accent mb-6">
          <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse" />
          Open to Product Management Roles
        </div>
      </div>

      <h1 className="text-primary text-5xl md:text-7xl font-bold leading-tight animate-fade-in-up animation-delay-100">
        {resumeData.name}
      </h1>

      <p className="text-2xl md:text-3xl font-semibold mt-4 animate-fade-in-up animation-delay-200">
        <span className="gradient-text">{resumeData.title}</span>
      </p>

      <p className="text-muted text-lg md:text-xl max-w-2xl mt-6 leading-relaxed animate-fade-in-up animation-delay-300">
        {resumeData.tagline}{" "}
        <span className="text-primary font-medium">
          NIT Calicut CS grad
        </span>{" "}
        with{" "}
        <span className="text-primary font-medium">
          2+ years shipping software
        </span>{" "}
        at scale. Now bringing product instincts, technical depth, and
        user empathy to PM.
      </p>

      <div className="flex flex-wrap gap-4 mt-8 animate-fade-in-up animation-delay-400">
        <a
          href="#projects"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-lg text-white font-semibold transition-all hover:scale-105"
          style={{
            background:
              "linear-gradient(135deg, var(--gradient-start), var(--gradient-end))",
          }}
        >
          View Case Studies
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M8 3v10M3 8l5 5 5-5" />
          </svg>
        </a>
        <a
          href={`https://${resumeData.github}`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-lg text-primary border border-card-border font-semibold hover:bg-tertiary transition-all"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
          </svg>
          GitHub
        </a>
      </div>

      {/* Quick stats */}
      <div className="grid grid-cols-3 gap-4 mt-12 max-w-md animate-fade-in-up animation-delay-500">
        {[
          { value: "2+", label: "Years Shipping" },
          { value: "20+", label: "Projects Delivered" },
          { value: "NIT", label: "Calicut CSE" },
        ].map((stat) => (
          <div
            key={stat.label}
            className="text-center p-3 rounded-lg border border-card-border bg-card-bg"
          >
            <div className="text-2xl font-bold gradient-text">{stat.value}</div>
            <div className="text-xs text-muted mt-1">{stat.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HeroSection;
